import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import HomePage from "./Components/Homepage/HomePage";
import Screener from "./Components/Screener/Screener";
import RankingNews from "./Components/Ranking_News/RankingNews";
import PrizeTargetNews from "./Components/Prize_Target_News/Prize_Target_News";
import TrendingNewsUpdate from "./Components/Trending_News/TrendingNews";
import LoginPage from "./Components/Login/Login";
import ManageSubscriptionPage from "./Components/Manage_Sub/Manag_Sub";
import PaymentForm from "./Components/Stripe/Stripe";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import Terms from "./Components/Terms/Terms"
import UpdatePassword from "./Components/UpdatePassword/UpdatePassword"

import { auth, firestore } from "./firebaseConfig"; // Import your Firebase setup
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import Loading from "./Components/ProtectedRoute/Loading"
import ForgotPasswordPage from "./Components/ForgotPassword/ForgotPassword"
import Contactus from "./Components/Contact_Us/Contact_Us"
import { HelmetProvider } from 'react-helmet-async';

function App() {
  const [user, setUser] = useState(null); // User authentication state
  const [isPaidUser, setIsPaidUser] = useState(false); // Payment status
  const [loading, setLoading] = useState(true); // Loading state

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setLoading(true); // Start loading when authentication state changes
      if (currentUser) {
        setUser(currentUser);

        // Fetch user details from Firestore
        const userDocRef = doc(firestore, "users", currentUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setIsPaidUser(userData.isPaidUserFlag || false);
        }
      } else {
        setUser(null);
        setIsPaidUser(false);
      }
      setLoading(false); // End loading after fetching user data
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    console.log("Current User: ", user);
    console.log("Is Paid User: ", isPaidUser);
  }, [user, isPaidUser]);

  if (loading) {
    // Show a loading spinner or placeholder while user state is being determined
    return <Loading/>;
  }

  return (
    <HelmetProvider>
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/screener" element={<Screener />} />
        <Route path="/ranking_news" element={<RankingNews />} />
        <Route path="/prize_target_news" element={<PrizeTargetNews />} />
        <Route path="/trending_news" element={<TrendingNewsUpdate />} />
        <Route path="/Terms" element={<Terms />} />
        <Route path="/ForgotPasswordPage" element={<ForgotPasswordPage />} />
        <Route path="/Contactus" element={<Contactus />} />


        <Route
          path="/UpdatePassword"
          element={
            <ProtectedRoute
              element={<UpdatePassword />}
              condition={user !== null}
              redirectTo="/login"
            />
          }
        />

        <Route
          path="/login"
          element={
            <ProtectedRoute
              element={<LoginPage />}
              condition={user == null}
              redirectTo="/"
            />
          }
        />

        {/* Protect ManageSubscription - Only logged-in users */}
        <Route
          path="/ManageSubscription"
          element={
            <ProtectedRoute
              element={<ManageSubscriptionPage />}
              condition={user !== null}
              redirectTo="/login"
            />
          }
        />

        {/* Protect PaymentForm - Only logged-in and unpaid users */}
        <Route
          path="/PaymentForm"
          element={
            <ProtectedRoute
              element={<PaymentForm />}
              condition={user !== null && isPaidUser === false}
              redirectTo={user !== null ? "/ManageSubscription" : "/login"}
            />
          }
        />
      </Routes>
    </Router>
    </HelmetProvider>
  );
}

export default App;
